import { inject, InjectionToken, Provider } from "@angular/core";
import { AbstractAgent } from "@ag-ui/client";
import { CopilotRuntimeTransport } from "@copilotkit/core";
import { ClientTool, FrontendToolConfig, RenderToolCallConfig } from "./tools";
import { ResolvedDebugConfig } from "@copilotkit/shared";

export interface AgentKitConfig {
  runtimeUrl?: string;
  runtimeTransport?: CopilotRuntimeTransport;
  headers?: Record<string, string>;
  properties?: Record<string, unknown>;
  agents?: Record<string, AbstractAgent>;
  selfManagedAgents?: Record<string, AbstractAgent>;
  tools?: ClientTool[];
  renderToolCalls?: RenderToolCallConfig[];
  frontendTools?: FrontendToolConfig[];
  debug?: ResolvedDebugConfig;
}

export const AGENT_KIT_CONFIG = new InjectionToken<AgentKitConfig>("AGENT_KIT_CONFIG");

export function injectAgentKitConfig(): AgentKitConfig {
  return inject(AGENT_KIT_CONFIG);
}

export function provideAgentKit(config: AgentKitConfig): Provider {
  return {
    provide: AGENT_KIT_CONFIG,
    useValue: config,
  };
}
